(function(){
  var nav=document.getElementById('nav');
  if(nav){ addEventListener('scroll',function(){nav.classList.toggle('scrolled',scrollY>8)},{passive:true}); }

  var sheet=document.getElementById('sheet'), menuBtn=document.getElementById('menuBtn'), sheetClose=document.getElementById('sheetClose');
  if(menuBtn&&sheet){
    menuBtn.onclick=function(){sheet.classList.add('open');document.body.style.overflow='hidden'};
    function closeSheet(){sheet.classList.remove('open');document.body.style.overflow=''}
    if(sheetClose)sheetClose.onclick=closeSheet;
    [].forEach.call(sheet.querySelectorAll('a'),function(a){a.onclick=closeSheet});
  }

  // tab active state
  var tabs=document.querySelectorAll('.tab[data-tab]');
  var bundles=document.getElementById('bundles');
  function setTab(){
    var onB=false;
    if(bundles){var b=bundles.getBoundingClientRect();onB=b.top<innerHeight*.5&&b.bottom>innerHeight*.4;}
    tabs.forEach(function(t){t.classList.toggle('active',t.dataset.tab===(onB?'bundles':'home'))});
  }
  if(tabs.length){setTab();addEventListener('scroll',setTab,{passive:true});}

  // reveal
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.1});
    document.querySelectorAll('.reveal').forEach(function(el){io.observe(el)});
  }

  // bundle builder
  var grid=document.getElementById('builderGrid');
  if(grid){
    var selected={};
    function money(c){return '$'+(c/100).toLocaleString('en-AU',{minimumFractionDigits:2,maximumFractionDigits:2});}
    function tierRate(n){return n>=4?.12:n>=3?.08:n>=2?.05:0;}
    function $(id){return document.getElementById(id);}
    function refresh(){
      var keys=Object.keys(selected).filter(function(k){return selected[k]});
      var n=keys.length, sub=keys.reduce(function(s,k){return s+selected[k].price},0);
      var rate=tierRate(n), disc=Math.round(sub*rate), total=sub-disc;
      $('sumCount').textContent=n+(n===1?' part':' parts');
      $('sumSub').textContent=money(sub);
      $('sumTotal').textContent=money(total);
      var dr=$('sumDiscRow');
      if(disc>0){dr.style.display='flex';$('sumDisc').textContent='-'+money(disc)+' ('+(rate*100)+'%)';}else dr.style.display='none';
      document.querySelectorAll('.tier').forEach(function(t){t.classList.toggle('hit',n>=+t.dataset.t&&tierRate(n)===tierRate(+t.dataset.t));});
      $('bundleAdd').disabled=n<2;
      var nu=$('bnudge');
      nu.textContent=n===0?'':n===1?'Add one more to unlock 5% off':n===2?'Add one more for 8% off':n===3?'Add one more for 12% off':'Max saving unlocked · 12% off';
    }
    grid.addEventListener('click',function(e){
      var el=e.target.closest('.pick');if(!el)return;
      var k=el.dataset.k;
      if(selected[k]){delete selected[k];el.classList.remove('on');}
      else{selected[k]={price:+el.dataset.price,vid:el.dataset.vid};el.classList.add('on');}
      refresh();
    });
    $('bundleAdd').onclick=function(){
      var items=Object.keys(selected).map(function(k){return {id:selected[k].vid,quantity:1};});
      if(!items.length)return;
      this.disabled=true;this.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){return r.json();})
        .then(function(){window.location.href='/cart';})
        .catch(function(){window.location.href='/cart';});
    };
    refresh();
  }

  // ajax add to cart (product cards + pdp)
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-add-id]');
    if(!b)return;
    e.preventDefault();
    var id=b.getAttribute('data-add-id');
    var orig=b.textContent;b.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})})
      .then(function(r){return r.json();})
      .then(function(){
        b.textContent='Added ✓';
        return fetch('/cart.js');
      })
      .then(function(r){return r?r.json():null;})
      .then(function(c){if(c){document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=c.item_count;});}
        setTimeout(function(){b.textContent=orig;},1400);
      })
      .catch(function(){b.textContent=orig;});
  });
})();
